import { ReturnTranslatedText } from '@wajeez-web/core/localization';

interface InputLabelProps {
  text: string | React.ReactNode;
  required?: boolean;
  name: string;
  hint?: string;
}

const InputLabel = ({
  text,
  name,
  hint,
  required = false,
}: InputLabelProps) => {
  return (
    <label
      htmlFor={name}
      className="flex leading-8 text-base font-medium text-gray-700"
    >
      <ReturnTranslatedText
        origintext={text?.toString()}
        text={`inputs.labels.${text}`}
      />{' '}
      {required && <div className="text-red-500">*</div>}
      {hint && <div className="ms-1 text-[13px] text-gray-500">({hint})</div>}
    </label>
  );
};

export default InputLabel;
